import { SxProps } from '@mui/material';
import { ChatBubbleOutline, CheckCircleOutline, Speed, FormatListBulleted, Equalizer, Scale } from '@mui/icons-material';
import { QuestionType } from '@/components/campaigns/CampaignQuestionsEditor/types';

interface QuestionTypeIconProps {
    type: QuestionType;
    useRatingScale?: boolean;
    iconStyle?: SxProps;
}

const QuestionTypeIcon: React.FC<QuestionTypeIconProps> = ({ type, useRatingScale = false, iconStyle = { fontSize: '14px' } }) => {
    switch (type) {
        case QuestionType.TEXT:
            return <ChatBubbleOutline sx={iconStyle} />;
        case QuestionType.BOOLEAN:
            return <CheckCircleOutline sx={iconStyle} />;
        case QuestionType.NUMERIC:
            return useRatingScale ? <Scale sx={iconStyle} /> : <Speed sx={iconStyle} />;
        case QuestionType.MULTISELECT:
            return <FormatListBulleted sx={iconStyle} />;
        case QuestionType.FORMULA:
            return <Equalizer sx={iconStyle} />;
        default:
            return null;
    }
};

export default QuestionTypeIcon;
